import styled, { css } from 'styled-components';

export const TopBar = styled.div<{ $light: boolean }>(
  ({ theme, $light }) => css`
    position: absolute;
    inset-inline: 0;
    top: 0;
    z-index: ${theme.zi.z3};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    padding: calc(${theme.sz.s3} + env(safe-area-inset-top)) ${theme.sz.s4} ${theme.sz.s6};
    background: ${$light ? 'transparent' : 'linear-gradient(hsla(0, 0%, 0%, 0.45), transparent)'};
    color: ${$light ? theme.co.neutral10 : theme.co.neutral99};
  `,
);

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BackButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: -${theme.sz.s1};
    padding: ${theme.sz.s1};
    border: 0;
    border-radius: ${theme.bo.round};
    background: none;
    color: inherit;
    font-size: ${theme.sz.s6};
    cursor: pointer;

    ${theme.focusVisible};

    [dir='rtl'] & {
      transform: scaleX(-1);
    }
  `,
);

export const Stats = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
  `,
);
